import { Controller } from "@hotwired/stimulus"

// A read-only illustration: selecting a control never changes application data.
export default class extends Controller {
  static targets = ["control", "panel", "connections"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.drawConnections())
    this.resizeObserver.observe(this.connectionsTarget.parentElement)
    this.drawConnections()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  drawConnections() {
    const svg = this.connectionsTarget
    const bounds = svg.getBoundingClientRect()
    if (!bounds.width || !bounds.height) return
    const edges = [["stolen", "access"], ["attachment", "endpoint"], ["access", "event"], ["endpoint", "event"], ["event", "restore"], ["event", "response"], ["restore", "stop"], ["response", "spread"]]
    const group = svg.querySelector("g")
    group.replaceChildren()
    edges.forEach(([source, target]) => {
      const from = this.element.querySelector(`[data-map-node="${source}"]`).getBoundingClientRect()
      const to = this.element.querySelector(`[data-map-node="${target}"]`).getBoundingClientRect()
      const x1 = from.right - bounds.left
      const y1 = from.top + from.height / 2 - bounds.top
      const x2 = to.left - bounds.left
      const y2 = to.top + to.height / 2 - bounds.top
      const midpoint = (x1 + x2) / 2
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
      path.setAttribute("d", `M${x1},${y1} H${midpoint} V${y2} H${x2}`)
      group.append(path)
    })
  }

  select(event) {
    const index = event.currentTarget.dataset.index
    this.controlTargets.forEach((control) => {
      control.setAttribute("aria-pressed", String(control.dataset.index === index))
    })
    this.panelTargets.forEach((panel, panelIndex) => {
      panel.hidden = String(panelIndex) !== index
    })
  }
}
